import React from 'react';
import GetAppIcon from '@mui/icons-material/GetApp';
import Button from '@mui/material/Button';
import { formatDate } from '../../utils/formatters';
import { makeColumnConfig } from '../../utils/table';

const createPrintCardColumn = ({
	onPrintCardDownload = () => {},
	downloadLabel = 'Download',
} = {}) => ({
	sortOrder: 5,
	isSortable: false,
	isVisible: true,
	getter: (row) => ({
		isSupported: !!row.PrintCard?.isSupported,
		productId: row.Item_Number,
	}),
	formatter: ({ isSupported, productId }) =>
		isSupported ? (
			<Button
				variant="outlined"
				color="primary"
				size="small"
				endIcon={<GetAppIcon fontSize="small" />}
				onClick={(event) => {
					event.stopPropagation();
					onPrintCardDownload({ productId });
				}}
				sx={{ minWidth: 100, textTransform: 'none' }}
			>
				{downloadLabel}
			</Button>
		) : (
			''
		),
});

const columnConfig = {
	Customer_Item_Number: {
		sortOrder: 0,
		isSortable: true,
		isVisible: true,
	},
	Design_Number: {
		sortOrder: 1,
		isSortable: true,
		isVisible: true,
	},
	Item_Description: {
		sortOrder: 2,
		isSortable: true,
		isVisible: true,
	},
	Order_Count: {
		sortOrder: 3,
		isSortable: true,
		isVisible: true,
	},
	Last_Ordered_Date: {
		sortOrder: 4,
		isSortable: true,
		isVisible: true,
		formatter: formatDate,
	},
	Print_Card: createPrintCardColumn(),
};

export const makeProductsColumnConfig = (options = {}) =>
	makeColumnConfig({
		...columnConfig,
		Print_Card: createPrintCardColumn(options),
	});

export default makeProductsColumnConfig();

export const columnOrder = Object.keys(columnConfig).sort(
	(a, b) => columnConfig[a].sortOrder > columnConfig[b].sortOrder
);

export const columnVisibility = Object.keys(columnConfig)
	.map((key) => ({ [key]: columnConfig[key].isVisible !== false }))
	.reduce((a, b) => ({ ...a, ...b }));
